import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";
import { PropertyService, PublicVisualizationService } from "../../../services";

export const getCurrentProperty = (propertyId, userId, isPublic = false) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_CURRENT_PROPERTY_REQUEST_STATUS,
      payload: { status: REQUEST_STATUSES.LOADING },
    });

    const payload = {};

    if (userId && !isPublic) {
      const { resp: property, status, err } = await PropertyService.getProperty(propertyId);
      payload.property = property ? { ...property, otherTag: property.tags[0] } : {};
      payload.status = status;
      payload.err = err;
    } else {
      const { resp: property, status, err } = await PublicVisualizationService.getPublicProperty(propertyId);
      payload.property = property || {};
      payload.status = status;
      payload.err = err;
    }

    dispatch({
      type: types.GET_CURRENT_PROPERTY,
      payload,
    });
  };
};

export const resetCurrentProperty = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_CURRENT_PROPERTY,
      payload: {},
    });
  };
};
